import { LOCALE_HTML_LANG, LOCALE_LABEL, SUPPORTED_LOCALES } from "./locale";
import { useI18n } from "./context";

// Unified language switcher for every React surface. `className` lets callers
// keep their existing skin (login uses `.login-lang`, the workspace can use
// `.lang-switch`) while the button set, order, and behaviour stay identical.
export function LanguageSwitcher({ className = "lang-switch" }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className={className} role="group" aria-label={t.common.language}>
      {SUPPORTED_LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          lang={LOCALE_HTML_LANG[code]}
          className={code === locale ? "is-on" : undefined}
          aria-pressed={code === locale}
          onClick={() => setLocale(code)}
        >
          {LOCALE_LABEL[code]}
        </button>
      ))}
    </div>
  );
}
